import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import LoaderGradient, {
    LOADER_GREY_GRADIENT_ID,
} from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";

const DEFAULT_ROW_COUNT = 5;
const DEFAULT_COLUMN_WIDTHS = ["20%", "20%", "47%"];

interface ICardRowsSkeletonProps {
    rowHeight: number;
    rowCount?: number;
    columnWidths?: string[];
    withHeaderRow?: boolean;
}

const CardRowsSkeleton = ({
    rowHeight,
    rowCount = DEFAULT_ROW_COUNT,
    columnWidths = DEFAULT_COLUMN_WIDTHS,
    withHeaderRow = false,
}: ICardRowsSkeletonProps) => {
    return (
        <Box padding="8px 24px 0">
            {withHeaderRow ? (
                <LoaderGradient
                    height={32}
                    width={120}
                />
            ) : null}
            {Array.from({ length: rowCount }).map((_, index) => (
                <Flex
                    key={index}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom={index === rowCount - 1 ? "none" : `1px solid ${colorsPalettes.carbon["100"]}`}
                    height={`${rowHeight}px`}
                    padding="0 20px"
                    margin={index === 0 ? "6px 0 0" : "0"}
                >
                    {columnWidths.map((width, columnIndex) => (
                        <Box
                            width={width}
                            key={columnIndex}
                        >
                            <LoaderGradient
                                height={6}
                                id={LOADER_GREY_GRADIENT_ID}
                            />
                        </Box>
                    ))}
                </Flex>
            ))}
        </Box>
    );
};

export default CardRowsSkeleton;
